import React from 'react';
import {
  AnimatedBackground,
  BentoGrid,
  HeroSection,
  ServicesSection,
  TechStackSection,
  ProjectsSection,
  ExperienceSection,
  CTASection,
  Footer
} from './components';
import './App.css';

/**
 * Main App Component
 * Portfolio for Braian Ariel Maciel
 * Bento Grid Layout + Dark Mode Premium Design
 */
function App() {
  return (
    <div
      className="min-h-screen w-full px-4 py-8 md:px-8 lg:px-16 xl:px-24"
      style={{
        background: 'var(--color-bg-primary)',
        color: 'var(--color-text-primary)'
      }}
    >
      {/* Animated Background with Parallax */}
      <AnimatedBackground />

      {/* Main Content Container */}
      <div className="relative max-w-7xl mx-auto">

        {/* Hero Section */}
        <HeroSection />

        {/* Bento Grid - Main Content */}
        <BentoGrid className="mb-8 md:mb-12" gap="0.75rem">
          {/* Services Card */}
          <ServicesSection />

          {/* Tech Stack Card (spans 2 columns) */}
          <TechStackSection />

          {/* Experience/Location Card */}
          <ExperienceSection />

          {/* Featured Project (spans 2 columns) + Secondary Projects */}
          <ProjectsSection />

          {/* CTA Card (spans full width) */}
          <CTASection />
        </BentoGrid>

        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
}

export default App;
